import React, {Fragment} from 'react';
import {translate} from 'react-i18next';
import {Card, Checkbox, Col, Form, Icon, Input, InputNumber, Row, Tooltip} from "antd";
import {compose} from "redux";
import _ from "lodash";
import {GUTTER_MD, MARGIN_MD, MARGIN_SM} from "../../../../styles/constants";

const mapPropsToFields = ({DataBrowser}) => ({
  DataBrowserUrl: Form.createFormField({value: DataBrowser && DataBrowser.DataBrowserUrl ? DataBrowser.DataBrowserUrl : ""}),
  NodeID: Form.createFormField({value: DataBrowser && DataBrowser.NodeID ? DataBrowser.NodeID : ""}),
  Enable: Form.createFormField({value: DataBrowser && DataBrowser.Enable ? DataBrowser.Enable : false}),
  URL: Form.createFormField({value: DataBrowser && DataBrowser.URL ? DataBrowser.URL : ""}),
  Username: Form.createFormField({value: DataBrowser && DataBrowser.Username ? DataBrowser.Username : ""}),
  Password: Form.createFormField({value: DataBrowser && DataBrowser.Password ? DataBrowser.Password : ""}),
  HTTPAuthEnable: Form.createFormField({value: DataBrowser && DataBrowser.HTTPAuthEnable ? DataBrowser.HTTPAuthEnable : false}),
  HTTPAuthUsername: Form.createFormField({value: DataBrowser && DataBrowser.HTTPAuthUsername ? DataBrowser.HTTPAuthUsername : ""}),
  HTTPAuthPassword: Form.createFormField({value: DataBrowser && DataBrowser.HTTPAuthPassword ? DataBrowser.HTTPAuthPassword : ""}),
  HTTPAuthDomain: Form.createFormField({value: DataBrowser && DataBrowser.HTTPAuthDomain ? DataBrowser.HTTPAuthDomain : ""}),
  ProxyEnable: Form.createFormField({value: DataBrowser && DataBrowser.ProxyEnable ? DataBrowser.ProxyEnable : false}),
  ProxyURL: Form.createFormField({value: DataBrowser && DataBrowser.ProxyURL ? DataBrowser.ProxyURL : ""}),
  ProxyPort: Form.createFormField({value: DataBrowser && DataBrowser.ProxyPort ? DataBrowser.ProxyPort : ""}),
  ProxyUsername: Form.createFormField({value: DataBrowser && DataBrowser.ProxyUsername ? DataBrowser.ProxyUsername : ""}),
  ProxyPassword: Form.createFormField({value: DataBrowser && DataBrowser.ProxyPassword ? DataBrowser.ProxyPassword : ""})
});

const onFieldsChange = (props, fields) =>
  props.onChange(_.mapValues(fields, ({value}) => value));

const DataBrowserForm = ({
                           t,
                           form
                         }) =>
  <Form>
    <Form.Item
      label={t('data.nodesConfig.dataBrowser.publicUrl.label')}
      style={{marginBottom: MARGIN_MD}}
    >
      {form.getFieldDecorator('DataBrowserUrl')(<Input/>)}
    </Form.Item>
    <Form.Item
      className={
        (form.getFieldValue("DataBrowserUrl") || form.getFieldValue("Enable"))
          ? "form-item-required"
          : null
      }
      label={t('data.nodesConfig.dataBrowser.nodeId.label')}
      style={{marginBottom: MARGIN_MD}}
    >
      {form.getFieldDecorator('NodeID', {normalize: _.toUpper})(<Input/>)}
    </Form.Item>
    <Card
      type="inner"
      style={{marginTop: MARGIN_MD, marginBottom: MARGIN_MD}}
    >
      <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}
           style={{marginBottom: 0}}>
        <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
          {t("data.nodesConfig.dataBrowser.enableCacheInvalidation.label") + ' :'}
        </Col>
        <Col>
          <Form.Item>
            {form.getFieldDecorator("Enable", {valuePropName: 'checked'})(
              <Checkbox/>
            )}
          </Form.Item>
        </Col>
      </Row>
      {form.getFieldValue("Enable") && (
        <Fragment>
          <Form.Item
            className="form-item-required"
            label={t('data.nodesConfig.dataBrowser.apiUrl.label')}
            style={{marginBottom: MARGIN_MD}}
          >
            {form.getFieldDecorator('URL')(<Input/>)}
          </Form.Item>
          <Card
            type="inner"
            title={
              <Fragment>
                {t("data.nodesConfig.dataBrowser.cards.authentication.label")}
                <Tooltip title={t("data.nodesConfig.dataBrowser.cards.authentication.tooltip")}>
                  <Icon type="info-circle" style={{marginLeft: MARGIN_SM}}/>
                </Tooltip>
              </Fragment>
            }
          >
            <Form.Item
              className="form-item-required"
              label={t('data.nodesConfig.dataBrowser.username.label')}
              style={{marginBottom: 0}}
            >
              {form.getFieldDecorator('Username')(<Input/>)}
            </Form.Item>
            <Form.Item
              label={t('data.nodesConfig.dataBrowser.password.label')}
              style={{marginBottom: 0}}
            >
              {form.getFieldDecorator('Password')(<Input type="password"
                                                         autoComplete="new-password"/>)}
            </Form.Item>
          </Card>
          <Card
            type="inner"
            title={t("data.nodesConfig.dataBrowser.cards.httpAuthentication.label")}
            style={{marginTop: MARGIN_MD, marginBottom: MARGIN_MD}}
          >
            <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}
                 style={{marginBottom: 0}}>
              <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
                {t("data.nodesConfig.dataBrowser.httpAuthenticationEnable.label") + ' :'}
              </Col>
              <Col>
                <Form.Item>
                  {form.getFieldDecorator("HTTPAuthEnable", {valuePropName: 'checked'})(
                    <Checkbox/>
                  )}
                </Form.Item>
              </Col>
            </Row>
            {form.getFieldValue("HTTPAuthEnable") && (
              <Fragment>
                <Form.Item
                  className="form-item-required"
                  label={t('data.nodesConfig.dataBrowser.httpAuthenticationUsername.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('HTTPAuthUsername')(<Input/>)}
                </Form.Item>
                <Form.Item
                  label={t('data.nodesConfig.dataBrowser.httpAuthenticationPassword.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('HTTPAuthPassword')(<Input/>)}
                </Form.Item>
                <Form.Item
                  label={t('data.nodesConfig.dataBrowser.httpAuthenticationDomain.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('HTTPAuthDomain')(<Input/>)}
                </Form.Item>
              </Fragment>
            )}
          </Card>
          <Card
            type="inner"
            title={t("data.nodesConfig.dataBrowser.cards.proxy.label")}
          >
            <Row type="flex" justify="start" align="middle" gutter={GUTTER_MD}
                 style={{marginBottom: 0}}>
              <Col style={{color: 'rgba(0, 0, 0, 0.85)'}}>
                {t("data.nodesConfig.dataBrowser.proxyEnable.label") + ' :'}
              </Col>
              <Col>
                <Form.Item>
                  {form.getFieldDecorator("ProxyEnable", {valuePropName: 'checked'})(
                    <Checkbox/>
                  )}
                </Form.Item>
              </Col>
            </Row>
            {form.getFieldValue("ProxyEnable") && (
              <Fragment>
                <Form.Item
                  className="form-item-required"
                  label={t('data.nodesConfig.dataBrowser.proxyUrl.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('ProxyURL')(
                    <Input/>
                  )}
                </Form.Item>
                <Form.Item
                  className="form-item-required"
                  label={t('data.nodesConfig.dataBrowser.proxyPort.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('ProxyPort')(
                    <InputNumber min={0} style={{width: "100%"}}/>
                  )}
                </Form.Item>
                <Form.Item
                  label={t('data.nodesConfig.dataBrowser.proxyUsername.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('ProxyUsername')(<Input/>)}
                </Form.Item>
                <Form.Item
                  label={t('data.nodesConfig.dataBrowser.proxyPassword.label')}
                  style={{marginBottom: 0}}
                >
                  {form.getFieldDecorator('ProxyPassword')(
                    <Input type="password" autoComplete="new-password"/>
                  )}
                </Form.Item>
              </Fragment>
            )}
          </Card>
        </Fragment>
      )}
    </Card>
  </Form>;

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(DataBrowserForm);




// WEBPACK FOOTER //
// ./src/scenes/configuration/nodes-config/node/DataBrowserForm.jsx